import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import api from '@/axios';
import {
  GET_PRODUCTION_DECLARATION_MATERIAL_COMMODITY_ORIGIN_DOCUMENTS_KEY,
  UPLOAD_PRODUCTION_DECLARATION_DOCUMENTS_KEY,
} from '@/keys';

type UploadProductionDeclarationDocumentsVariables = {
  productionDeclarationId: string;
  materialId: string;
  commodityOriginId: string;
  file: File;
  token?: string;
};

async function uploadSingleDocument({
  productionDeclarationId,
  materialId,
  commodityOriginId,
  file,
  token,
}: UploadProductionDeclarationDocumentsVariables): Promise<void> {
  const formData = new FormData();
  formData.append('file', file);

  await api.post(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/commodity-origins/${commodityOriginId}/documents`,
    formData,
    {
      params: token ? { token } : undefined,
      transformRequest: [
        (data, headers) => {
          if (data instanceof FormData) {
            headers['Content-Type'] = undefined;
          }

          return data;
        },
      ],
    },
  );
}

export function useUploadProductionDeclarationDocuments(): UseMutationResult<
  void,
  unknown,
  UploadProductionDeclarationDocumentsVariables
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: UPLOAD_PRODUCTION_DECLARATION_DOCUMENTS_KEY,
    mutationFn: uploadSingleDocument,
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [
          ...GET_PRODUCTION_DECLARATION_MATERIAL_COMMODITY_ORIGIN_DOCUMENTS_KEY,
          variables.productionDeclarationId,
          variables.materialId,
          variables.commodityOriginId,
          variables.token ?? '',
        ],
      });
    },
  });
}
